
  document.addEventListener('DOMContentLoaded', function() {
    new Swiper('.swiper.card-swipes-slider', {
      loop: true,
      slidesPerView: 1,
      navigation: {
      nextEl: ".swiper-button-next.card-product-arrows",
      prevEl: ".swiper-button-prev.card-product-arrows"
    }
    });
  });